import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class WhVisaApply extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={1319} />;
  }
}
export default WhVisaApply;
